// extracted by mini-css-extract-plugin
export var bottomSection = "CommencementSection-module--bottomSection--9933d";
export var commencementSection = "CommencementSection-module--commencementSection--77323";
export var heading = "CommencementSection-module--heading--5db44";
export var headingBlock = "CommencementSection-module--headingBlock--a25cd";
export var horizontal = "CommencementSection-module--horizontal--fe422";
export var horizontalStores = "CommencementSection-module--horizontalStores--725da";
export var image = "CommencementSection-module--image--2bc7f";
export var imageWrap = "CommencementSection-module--imageWrap--c9525";
export var step = "CommencementSection-module--step--8570c";
export var step2 = "CommencementSection-module--step2--38554";
export var stepBlock = "CommencementSection-module--stepBlock--0ae26";
export var stepHeading = "CommencementSection-module--stepHeading--8bcd5";
export var stepSubtitle = "CommencementSection-module--stepSubtitle--c9c16";
export var stepText = "CommencementSection-module--stepText--19d3c";
export var stepsSection = "CommencementSection-module--stepsSection--c4a61";
export var storesBlock = "CommencementSection-module--storesBlock--4eb41";
export var subheading = "CommencementSection-module--subheading--18663";
export var title = "CommencementSection-module--title--c7ad5";